import { FormControl, styled } from '@mui/material';

const PREFIX = 'SelectMultiple';

export const classes = {
  root: `${PREFIX}-root`,
  select: `${PREFIX}-select`,
  bold: `${PREFIX}-bold`,
  icon: `${PREFIX}-icon`,
};

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`&.${classes.root}`]: {
    width: '100%',
  },

  [`& .${classes.select}`]: {},

  [`& .${classes.bold}`]: {
    fontWeight: 'bold',
  },

  [`& .${classes.icon}`]: {
    padding: 0,
    paddingRight: theme.spacing(2),
  },
}));